import _get from 'lodash/get';

import { BonnetModule } from '@bonnet/next/modules';

import { brands } from '@atc/brand';
import { objectDuckCreator } from '@atc/modular-redux';

import getPathSRP from '@/utilities/getPathSRP';

export async function buildSearchUrlFromRequest(ctx) {
    const query = { ...ctx.query };
    delete query.listingId;
    delete query.lnx;
    delete query.clickType;

    const makeCode = query?.makeCode || _get(ctx, 'data.listings[0].makeCode');
    const modelCode = query?.modelCode || _get(ctx, 'data.listings[0].modelCode');
    const zip = query?.zip || _get(ctx, 'data.zip');

    return getPathSRP({
        makeCode,
        modelCode,
        zip,
        ...query,
    });
}

export async function getUrlFromCtx(ctx) {
    const isFord = ctx.data?.brand === brands.FORD_BRAND;
    const referrer = ctx.req?.headers?.referer;

    try {
        // assume that any referrer that begins with the BASE_PATH is an internal page opened in a "new tab"
        // return undefined to avoid generating a SRP link
        const { pathname } = new URL(referrer);
        if (pathname.startsWith(process.env.BASE_PATH)) {
            return undefined;
        }
    } catch (err) {
        // allow invalid referrers to pass through
    }

    // FORD VDPs need to be returned to the default FORD SRP
    if (isFord) {
        return `${process.env.BASE_PATH}/all`;
    }

    // If we have reached this point on either from an external application or from an email/bookmark/etc.
    // Generate a URL from the listing data or page query
    return buildSearchUrlFromRequest(ctx);
}

export function SearchLinkModuleCtxMiddleware({ duck }) {
    return async (ctx) => {
        ctx.batchDispatch.createActions(async (_ctx) => {

            // check for a req object on the ctx to assert that we are an initial server render
            // if there is no ctx.req then we assume that this is the result of a SPA action
            // and set it to undefined
            const url = ctx.req && await getUrlFromCtx(_ctx);

            return duck.creators.setKeys({
                label: 'View similar vehicles',
                link: url,
            });
        });
    };
}

const SearchLinkModule = new BonnetModule({
    duck: objectDuckCreator({
        store: 'searchLink',
    }),

    ctxMiddleware: SearchLinkModuleCtxMiddleware,
});

export default SearchLinkModule;
